module.exports = __webpack_public_path__ + "static/img/nicePng_bas.21088c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/nicePng_bas.png
// module id = zCCI
// module chunks = 66